import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import {
    createItemListColumnPreferences,
    normalizeItemListColumnPreferences,
    ItemListColumnPreferences,
} from '../../items/model/item-list.types';
import ItemListColumnConfigTable from '../../items/components/ItemListColumnConfigTable';
import { UserConfigInputs } from '../model/user-config.types';


const ItemListColumnConfigFields: React.FC = () => {
    const { control, setValue } = useFormContext<UserConfigInputs>();
    const rawPreferences = useWatch({ control, name: 'item_list_column_config' });
    const preferences = React.useMemo(
        () => normalizeItemListColumnPreferences(rawPreferences),
        [rawPreferences],
    );
    const handlePreferencesChange = (newPreferences: ItemListColumnPreferences) => {
        setValue(
            'item_list_column_config',
            newPreferences,
        );
    };
    const handleResetToDefault = () => {
        setValue(
            'item_list_column_config',
            createItemListColumnPreferences(),
        );
    };


    return (
        <div className="col-12">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <p className="text-muted small mb-0">드래그하여 컬럼 순서를 변경할 수 있습니다.</p>
                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={handleResetToDefault}>
                    기본값으로 되돌리기
                </button>
            </div>
            <ItemListColumnConfigTable
                preferences={preferences}
                onPreferencesChange={handlePreferencesChange}
            />
        </div>
    );
}

export default ItemListColumnConfigFields;
